import { render } from "./MenuIcon.vue?vue&type=template&id=4494d4c0"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MenuIcon.vue?vue&type=style&index=0&id=4494d4c0&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__